import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=380ed0af&scoped=true"
import script from "./Templates.vue?vue&type=script&lang=js"
export * from "./Templates.vue?vue&type=script&lang=js"
import style0 from "./Templates.vue?vue&type=style&index=0&id=380ed0af&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380ed0af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('380ed0af')) {
      api.createRecord('380ed0af', component.options)
    } else {
      api.reload('380ed0af', component.options)
    }
    module.hot.accept("./Templates.vue?vue&type=template&id=380ed0af&scoped=true", function () {
      api.rerender('380ed0af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/Templates.vue"
export default component.exports